module.exports = {
      id: "shareicon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#shareicon",
      toString: function () {
        return this.url;
      }
    }